"use client";
import getPublicClient from "@/lib/algolia/getPublicClient";
import { Configure, ConfigureProps, InstantSearch } from "react-instantsearch";
import { PRODUCT_INDEX_EN } from "@/constants/algolia";
import getFilters from "@/components/Search/utils/getFilters";
import PartnerProgramSearchHits from "./PartnerProgramSearchHits";
import CohesionConfig from "../Cohesion";

const searchClient = getPublicClient();

export type PartnerProgramRecommendationsExperimentProps = {
  title?: string;
  subtitle?: string;
  cardsToDisplay?: number;
  customConfigForSearch?: ConfigureProps;
  titleComponent?: React.ReactNode;
};

export interface PartnerProgramRecommendationsProps
  extends PartnerProgramRecommendationsExperimentProps {
  searchIndex?: string;
  partners?: string[];
  location?: string;
  pageType?: string;
}

function PartnerProgramRecommendations(
  props: PartnerProgramRecommendationsProps,
) {
  const indexName = props.searchIndex || PRODUCT_INDEX_EN;

  const configForSearch = props.customConfigForSearch || {
    filters: getFilters({ productType: "program" }),
    disjunctiveFacets: ["partner"],
    disjunctiveFacetsRefinements: { partner: props.partners || [] },
    facets: ["product"],
    clickAnalytics: true,
    facetsRefinements: { product: ["program"] },
    hitsPerPage: props.cardsToDisplay || 5,
  };

  return (
    <>
      <CohesionConfig pagetype={props.pageType || "other"} />
      <InstantSearch
        searchClient={searchClient}
        indexName={indexName}
        future={{
          preserveSharedStateOnUnmount: true,
        }}
      >
        <Configure {...configForSearch} />
        <PartnerProgramSearchHits
          location={props.location}
          title={props.title}
          subtitle={props.subtitle}
          titleComponent={props.titleComponent}
          indexName={indexName}
        />
      </InstantSearch>
    </>
  );
}

export default PartnerProgramRecommendations;
